import { Button, useToast } from '@mevaser/ui'
import { Copy } from 'lucide-react'

/** A small icon button that copies one value, e.g. a customer's phone or address (t1252). */
export function CopyButton({ value, label }: { value: string; label: string }) {
  const toast = useToast()

  async function copy() {
    try {
      await navigator.clipboard.writeText(value)
      toast.success('Copied')
    } catch {
      toast.error('Could not copy — select the text and copy it by hand')
    }
  }

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      aria-label={`Copy ${label}`}
      title={`Copy ${label}`}
      onClick={() => void copy()}
    >
      <Copy className="size-3.5" aria-hidden="true" />
    </Button>
  )
}
